var _linearGradient, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGradientBackground = function SvgGradientBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    preserveAspectRatio: "none",
    viewBox: "0 0 463 193"
  }, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradientBackground_svg__a",
    x1: 464.032,
    x2: 324.942,
    y1: 0.265,
    y2: 331.355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#427cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#654acf"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gradientBackground_svg__a)",
    d: "M63.286.265h400v196H-.322c0-76.058 62.862-118.702 62.862-194.76z"
  })));
};
export { SvgGradientBackground as ReactComponent };